import { LuInstagram } from "react-icons/lu";
import React from "react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-d-background text-white py-12">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-8">
          <h3 className="text-xl font-light mb-4 tracking-wider">
            SHASZ STUDIOS
          </h3>
          <p className="text-sm opacity-75 font-light max-w-md mx-auto leading-relaxed">
            Capturing life's beautiful moments with artistry and passion.
          </p>
        </div>

        <div className="flex justify-center space-x-8 mb-8">
          <a
            href="https://www.instagram.com/shaszstudios?igsh=MWwzbXlsY3oyNG95dw%3D%3D&utm_source=qr"
            target="_blank"
            rel="noreferrer"
            className="text-sm hover:text-[#548e9b] transition-colors font-light tracking-wide"
          >
            <span className="flex items-center gap-2">
              <LuInstagram
                className="text-white hover:text-primary"
                size={20}
              />
              INSTAGRAM
            </span>
          </a>
        </div>

        <div className="border-t border-gray-700 pt-8 text-center">
          <p className="text-xs opacity-75 font-light tracking-wide">
            &copy; {currentYear} SHASZ STUDIOS. ALL RIGHTS RESERVED.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
